module.exports = __webpack_public_path__ + "static/media/noyeks.81245707.png";